import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";
import { _CheckOpenPaymentStudentNo } from "../../models/pay";
import { formToObject } from "../../utils";
import { Toast } from "antd-mobile";

const FindStudentForm = (props) => {
  const context = useContext(PsContext);

  const [validater, setValidater] = useState([]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidater(true);
      return;
    }
    context.setLoader(true);
    _CheckOpenPaymentStudentNo(formToObject(form)).then((res) => {
      if (res.status == "1") {
        if (props.onSuccess) props.onSuccess(res.data);
      } else {
        Toast.show({ content: res.message || "Register No Not Exist" });
      }
      context.setLoader(false);
    });
  };

  return (
    <div data-aos="zoom-in">
      <Form
        action=""
        method="post"
        noValidate
        validated={validater}
        onSubmit={handleFormSubmit}
      >
        <Row>
          <Col>
            <Form.Control
              type="text"
              name="registerno"
              className="fw-bold"
              placeholder="Register Number"
              autoComplete="off"
              autoFocus={true}
              required
            />
          </Col>
          <label className="py-2 ms-2">
            If you don't know your registration number, please contact your
            college to obtain it.
          </label>
        </Row>
        <Row className="mt-3">
          <Col md={12}>
            <Button type="submit" variant="danger" className="w-100" size="lg">
              Go Next
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default FindStudentForm;
